import React from 'react';

/**
 * Componente para buscar y mostrar productos del catálogo
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.searchTerm - Término de búsqueda actual
 * @param {Function} props.setSearchTerm - Función para actualizar el término de búsqueda
 * @param {Array} props.filteredEquiposCatalog - Lista de equipos filtrados
 * @param {Function} props.handleEquipoSelect - Función para manejar la selección de un equipo
 * @param {Array} props.grupos - Lista de grupos de instalación
 * @param {Array} props.tipos - Lista de tipos de instalación
 * @param {Array} props.medidas - Lista de medidas de instalación
 * @returns {JSX.Element} - Componente de navegación del catálogo
 */
const CatalogBrowser = ({
  searchTerm,
  setSearchTerm,
  filteredEquiposCatalog,
  handleEquipoSelect,
  grupos,
  tipos,
  medidas,
}) => {
  return (
    <div className="catalog-mode-container">
      <div className="catalog-search">
        <input
          type="text"
          placeholder="Buscar por descripción..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="catalog-search-input"
          autoFocus
        />
        <i className="fa-solid fa-search catalog-search-icon"></i>
      </div>
      
      <div className="catalog-table-container">
        <table className="catalog-table">
          <thead>
            <tr>
              <th className="catalog-th">Descripción</th>
              <th className="catalog-th">Medida</th>
              <th className="catalog-th">Stock</th>
            </tr>
          </thead>
          <tbody>
            {filteredEquiposCatalog.length > 0 ? (
              filteredEquiposCatalog.map((equipo) => (
                <tr 
                  key={equipo.idequipoinstalacion} 
                  onClick={() => handleEquipoSelect(equipo)}
                  className="catalog-table-row"
                >
                  <td className="catalog-td">{equipo.descripcion || "-"}</td>
                  <td className="catalog-td">
                    {medidas.find(m => m.idmedidainstalacion === equipo.idmedidainstalacion)?.medidainstalacion || "-"}
                  </td>
                  <td className="catalog-td">{equipo.stock || "0"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="catalog-empty-message">
                  {searchTerm ? (
                    <>
                      <i className="fa-solid fa-search"></i>
                      <p>No se encontraron resultados para "{searchTerm}"</p>
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-keyboard"></i>
                      <p>Ingrese texto para buscar equipos</p>
                    </>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default React.memo(CatalogBrowser);